import clsx from 'classnames'
import * as React from 'react'

export interface YearProps {
  children: React.ReactNode
  disabled?: boolean
  onSelect: (value: any) => void
  selected?: boolean
  value: any
  forwardedRef?: React.Ref<HTMLDivElement>
}

export const Year: React.FunctionComponent<YearProps> = ({
  onSelect,
  forwardedRef,
  value,
  selected,
  disabled,
  children,
  ...other
}) => {
  const handleClick = React.useCallback(() => onSelect(value), [onSelect, value])

  return (
    <div
      role='button'
      tabIndex={disabled ? -1 : 0}
      onClick={handleClick}
      onKeyPress={handleClick}
      color={selected ? 'primary' : undefined}
      ref={forwardedRef}
      className={clsx(
        'MuiPickersYear-root',
        {
          'MuiPickersYear-yearSelected': selected,
          'MuiPickersYear-yearDisabled': disabled,
        },
        selected ? 'mt-typography-h5' : 'mt-typography-subtitle1',
      )}
      {...other}
    >
      {children}
    </div>
  )
}

Year.displayName = 'Year'

export default React.forwardRef<HTMLDivElement, YearProps>((props, ref) => <Year {...props} forwardedRef={ref} />)
